import React from 'react'
import { useState, useEffect } from 'react';
import { AiOutlineClose, AiOutlineMenu } from 'react-icons/ai';
import { Link } from 'react-router-dom';
import { Link as ScrollLink } from 'react-scroll';

import { FaWhatsapp } from "react-icons/fa";


// import logo from '../images/64.png'
import logo from '../images/BLACK1.webp'
import black from '../images/BLACK1.webp'



const Header = () => {

    // State to manage the navbar's visibility
    const [nav, setNav] = useState(false);


    // Toggle function to handle the navbar's display
    const handleNav = () => {
        setNav(!nav);
    };


    //color change
    const [navbarBg, setNavbarBg] = useState('bg-[#f2f2f2]');


    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 50) {
                setNavbarBg('bg-[#dce0e5] shadow-md ');
            } else {
                setNavbarBg('bg-[#f2f2f2]');
            }
        };

        window.addEventListener('scroll', handleScroll);

        // Remove event listener on cleanup
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);


    function topPage() {
        window.scroll(0, 0)
    }

    //mobile view click the link hide the navbar

    const [hide, setHide] = useState(true)

    function clicklink() {
        setHide(false)
    }


    return (
        <>
            {/* -------- second navbar ------- */}

            <nav className={` w-full sticky top-0 z-30  py-6 md:py-5 border-b pb-3 border-white ${navbarBg} `}>
                <div className="max-w-full mx-auto font-[Open Sans]  ">
                    {/* Logo */}
                    <div className='flex justify-between items-center px-4 sm:px-9 w-full xl:w-[90%] mx-auto'>


                        <div className='w-full'>
                            <Link to='https://cinemafactory.co.in/' onClick={topPage}>
                                <img src={logo} className='w-44 sm:w-44 md:w-64 object-cover' alt="" />
                            </Link>
                        </div>


                        {/* Desktop Navigation */}
                        <ul className='hidden lg:flex w-full font-bold gap-x-4 xl:gap-x-8' >


                            {/* <li className='  cursor-pointer duration-300 text-gray-800  text-[12px] xl:text-[14px] ' >
                                <ScrollLink to="about" smooth={true} duration={500} onClick={topPage}>
                                    <p className="relative group flex items-center">
                                        <button class="tracking-[.02em]  hover:text-black/65 font-bold  focus:text-red-600">About Us</button>
                                    </p>
                                </ScrollLink>
                            </li> */}


                            <li className='  cursor-pointer duration-300 text-gray-800 font-bold text-[12px] xl:text-[14px]' >

                                <ScrollLink to="course" smooth={true} duration={500} onClick={topPage}>
                                    <p className="relative group flex items-center">
                                        <button class=" tracking-[.02em]  hover:text-black/65  focus:text-red-600">Courses</button>
                                    </p>
                                </ScrollLink>

                            </li>
                            <li className=' cursor-pointer duration-300 text-gray-800 font-bold text-[12px] xl:text-[14px]' >

                                <ScrollLink to="mentors" smooth={true} duration={500} onClick={topPage}>
                                    <p className="relative group flex items-center">
                                        <button class=" tracking-[.02em]  hover:text-black/65  focus:text-red-600">Mentors</button>
                                    </p>
                                </ScrollLink>

                            </li>
                            <li className=' cursor-pointer duration-300 text-gray-800 font-bold text-[12px] xl:text-[14px]' >

                                <ScrollLink to="contact" smooth={true} duration={500} onClick={topPage}>
                                    <p className="relative group flex items-center">
                                        <button class=" tracking-[.02em]  hover:text-black/65  focus:text-red-600">Contact</button>
                                    </p>
                                </ScrollLink>
                            </li>

                        </ul>

                        <div className='cursor-pointer'>
                            <a href="https://api.whatsapp.com/send?phone=9884683888" target="_blank" rel="noopener noreferrer" className="">

                                <div className=' w-6 h-6 md:h-8 md:w-8 bg-green-600 rounded-full duration-300 shadow-sm drop-shadow-md shadow-gray-100 hover:shadow-green-200 hover:shadow-sm hover:drop-shadow-md hover:scale-105 flex  justify-center items-center  '>
                                    <FaWhatsapp className=' rounded-full text-[16px] md:text-[21px]  text-white' />
                                </div>
                            </a>

                            {/* <button className='font-boldhover:text-gray-950 px-3.5 py-1 uppercase text-[13px] rounded-md text-white border border-white hover:bg-white'>Contact</button> */}
                        </div>


                        {/* Mobile Navigation Icon */}
                        <div onClick={handleNav} className='block lg:hidden'>
                            {nav ? <AiOutlineClose className='w-16 sm:w-16 md:w-20 text-gray-900' /> : <AiOutlineMenu className='w-16 sm:w-16 md:w-20 text-gray-900' />}
                        </div>

                        {/* Mobile Navigation Menu */}
                        {
                            hide &&
                            <ul
                                className={
                                    nav
                                        ? 'fixed lg:hidden left-0 top-0 w-[60%] h-[100%] border-r  bg-gray-50 ease-in-out duration-500'
                                        : 'ease-in-out w-[60%] duration-500 fixed top-0 bottom-0 left-[-100%]'
                                }
                            >
                                {/* Mobile Logo */}

                                <Link to='https://cinemafactory.co.in/' onClick={topPage} className='w-full' >
                                    <img src={black} className=' w-36 sm:w-40  pt-10  ml-10' alt="" onClick={handleNav} />
                                </Link>



                                {/* Mobile Navigation Items */}

                                {/* <li className=' ml-10 cursor-pointer duration-300 text-gray-700  text-[13px] mt-8' >
                                    <a href="#about" onClick={topPage}>
                                        <p className="relative group flex items-center">
                                            <button class="font-boldtracking-[.02em]  hover:text-white/50  focus:text-red-600" onClick={handleNav}>About Us</button>
                                        </p>


                                    </a>
                                </li> */}

                                {/* <li className=' ml-10 cursor-pointer duration-300 text-gray-500  text-[13px] mt-8' >
                                    <a href="#fourteen" onClick={topPage}>

                                        <p className="relative group flex items-center">
                                            <button class="font-boldtracking-[.02em]  hover:text-white/50  focus:text-red-600" onClick={handleNav}>Fourteen Crafts</button>
                                        </p>
                                    </a>

                                </li> */}

                                <li className=' ml-10 cursor-pointer duration-300 text-gray-500  text-[13px] mt-8' >
                                    <a href="#course" onClick={topPage}>
                                        <p className="relative group flex items-center">
                                            <button class="font-bold tracking-[.02em]  hover:text-white/50  focus:text-red-600" onClick={handleNav}>Courses</button>
                                        </p>
                                    </a>
                                </li>

                                <li className=' ml-10 cursor-pointer duration-300 text-gray-500  text-[13px] mt-8' >
                                    <a href="#mentors" onClick={topPage}>

                                        <p className="relative group flex items-center">
                                            <button class="font-bold tracking-[.02em]  hover:text-white/50  focus:text-red-600" onClick={handleNav}>Mentors</button>
                                        </p>
                                    </a>
                                </li>

                                <li className=' ml-10 cursor-pointer duration-300 text-gray-500  text-[13px] mt-8' >
                                    <a href="#contact" onClick={topPage}>

                                        <p className="relative group flex items-center">
                                            <button class="font-bold tracking-[.02em]  hover:text-white/50  focus:text-red-600" onClick={handleNav}>Contact</button>
                                        </p>
                                    </a>
                                </li>
                            </ul>
                        }

                    </div>
                </div>
            </nav>

        </>
    )
}

export default Header